import { useState } from "react";
import { Grid } from "@mui/material";
import Text from "@/components/Text";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import { EyeVisibilityIcon } from "@/components/svg-icons/material-icons";
import useDisclosure from "@/hooks/use-disclosure";
import {
  IntakeFormSection,
  IntakePreviewModal,
} from "@/pages/app/provider/scheduling/appointment";
import {
  APPOINTMENT_DETAIL_SEPARATOR,
  PATIENT_FORMS_LABEL,
} from "../group-appointment-constant";
import { PatientFormItem } from "../group-appointment-types";
import { usePatientForms } from "../hooks/use-patient-forms";

export type PatientFormsPanelProps = {
  appointmentId: string;
  customForms: string | null;
};

const mutedText = {
  ...CHART_TYPOGRAPHY.body5,
  c: CHART_COLORS.textMutedGrey,
};

const PatientFormsPanel = ({
  appointmentId,
  customForms,
}: PatientFormsPanelProps) => {
  const previewDisclosure = useDisclosure();
  const [previewSection, setPreviewSection] = useState<IntakeFormSection>();
  const { forms, submittedForm, isLoading, isError } = usePatientForms(
    appointmentId,
    customForms
  );

  const openPreview = (form: PatientFormItem) => {
    setPreviewSection(form.name as IntakeFormSection);
    previewDisclosure.open(submittedForm);
  };

  if (isLoading || isError) {
    return (
      <Text {...mutedText} sx={{ px: 2, pb: 1.25 }}>
        {isLoading
          ? PATIENT_FORMS_LABEL.loading
          : PATIENT_FORMS_LABEL.loadError}
      </Text>
    );
  }

  return (
    <Grid container rowSpacing={0.75} sx={{ px: 2, pb: 1.5 }}>
      {forms.map((form) => (
        <Grid key={form.name} container size={12} sx={{ alignItems: "center" }}>
          <Grid size={5}>
            <Text {...mutedText}>{form.label}</Text>
          </Grid>
          <Grid size={0.5}>
            <Text {...mutedText}>{APPOINTMENT_DETAIL_SEPARATOR}</Text>
          </Grid>
          <Grid size={6.5}>
            {form.isSubmitted ? (
              <StyledButtonV2
                label={PATIENT_FORMS_LABEL.previewForm}
                variant="text"
                startIcon={<EyeVisibilityIcon fontSize="small" />}
                onClick={() => openPreview(form)}
              />
            ) : (
              <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textDarker}>
                {PATIENT_FORMS_LABEL.notSubmitted}
              </Text>
            )}
          </Grid>
        </Grid>
      ))}

      <IntakePreviewModal
        disclosureHost={previewDisclosure}
        selectedSection={previewSection ? [previewSection] : undefined}
        _showTabs
      />
    </Grid>
  );
};

export default PatientFormsPanel;
